import { JMCLink } from "@components/JMCLink/JMCLink";
import { useLocale } from "@jmc/core/src/hooks/useLocale";
import { Button } from "@jmc/solid-design-system/src/components/atoms/Button/Button";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import path from "@jmc/utils/utils/path";
import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

interface Props {
    title?: string;
}

export const Maintenance = ({ title }: Props): JSX.Element => {
    const { t } = useTranslation();
    const locale = useLocale();
    const { jnjFullBranded } = useJnjBranding();

    return (
        <div data-test-id="maintenance" className={styles.maintenance}>
            {jnjFullBranded ? (
                <div className={styles.container}>
                    <Typography variant="h1" size="4xl" data-test-id="Maintenance.Title" className={styles.title}>
                        {title}
                    </Typography>
                    <Typography data-test-id="Maintenance.Text" size="l" className={styles.text}>
                        {t("maintenance_text", { ns: "common" })}
                    </Typography>
                    <JMCLink url={path.join(process.env.GATSBY_APP_DOMAIN, locale)} data-test-id="Maintenance.GoBack">
                        <Button color="secondary" data-test-id="Maintenance.GoBack.Button">
                            {t("Back to the homepage", { ns: "common" })}
                        </Button>
                    </JMCLink>
                </div>
            ) : (
                <>
                    <Typography variant="h1" data-test-id="Maintenance.Title">
                        {t("default_maintenance_title", { ns: "common" })}
                    </Typography>
                    <Typography data-test-id="Maintenance.Text">{t("maintenance_text", { ns: "common" })}</Typography>
                    <JMCLink url={path.join(process.env.GATSBY_APP_DOMAIN, locale)} data-test-id="Maintenance.GoBack">
                        <Button color="secondary" data-test-id="Maintenance.GoBack.Button">
                            {t("Back to the homepage", { ns: "common" })}
                        </Button>
                    </JMCLink>
                </>
            )}
        </div>
    );
};
